import { render, staticRenderFns } from "./ResultComponent.vue?vue&type=template&id=4487df60&scoped=true"
import script from "./ResultComponent.vue?vue&type=script&lang=js"
export * from "./ResultComponent.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./ResultComponent.vue?vue&type=style&index=0&id=4487df60&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4487df60",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fulfillment-previred-widget/fulfillment-previred-widget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4487df60')) {
      api.createRecord('4487df60', component.options)
    } else {
      api.reload('4487df60', component.options)
    }
    module.hot.accept("./ResultComponent.vue?vue&type=template&id=4487df60&scoped=true", function () {
      api.rerender('4487df60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResultComponent.vue"
export default component.exports